import axios from "axios";
import { message } from "antd";
import { apiHeaders } from "../helper/apiHeader";
import { getStudentData } from "../helper/localStorage";

export const fetchAssignedTest = (gradeId, dispatch) => {
  dispatch({ type: "ASSIGNED_TEST_LOADER" });
  const myData = { data: { id: getStudentData().login_id, grade_id: gradeId, mappr_tracker : 'Y' } };
  axios
    .post("/UserProfile", myData, apiHeaders("plrtestlist"))
    .then((res) => {
      if (res.data.status === "201") {
        dispatch({ type: "ASSIGNED_TEST_DATA", payload: res.data });
      } else {
        if (res.data.msg === "No data found") {
          dispatch({ type: "TEST_AVAILABILITY", payload: false });
        } else {
          dispatch({ type: "ASSIGNED_TEST_ERR" });
          message.error(res.data.msg);
        }
      }
    })
    .catch((err) => {
      message.error("Please wait for sometime or check your internet connection. Try again");
      dispatch({ type: "ASSIGNED_TEST_ERR" });
    });
};
